
export class Usuario {
  acessoPortal?: boolean;
  cadastroMobile?: boolean;
  cns?: string;
  cnsCartao?: string;
  cpf?: string;
  dataNascimento?: number;
  doadorOrgao?: boolean;
  email?: string;
  emailAlternativoValidado?: boolean;
  emailPrincipalValidado?: boolean;
  encontradoReceita?: boolean;
  enderecoBairro?: string;
  enderecoBairroCodigo?: string;
  enderecoCep?: string;
  enderecoCodigo?: number;
  enderecoComplemento?: string;
  enderecoLogradouro?: string;
  enderecoMunicipio?: string;
  enderecoMunicipioCodigo?: string;
  enderecoMunicipioSemUF?: string;
  enderecoNumero?: string;
  enderecoTipoLogradouro?: string;
  enderecoTipoLogradouroCodigo?: string;
  etniaIndigena?: string;
  grauQualidade?: string;
  listaCns?: Array<string>;
  municipioNascimento?: string;
  municipioNascimentoCodigo?: string;
  municipioNascimentoSemUF?: string;
  nacionalidade?: string;
  nomade?: string;
  nome?: string;
  nomeMae?: string;
  nomePai?: string;
  nomeSocial?: string;
  paisNascimento?: string;
  paisNascimentoCodigo?: string;
  paisResidenciaCodigo?: string;
  paisResidenciaDescricao?: string;
  racaCor?: string;
  racaCorDescricao?: string;
  rgCodigo?: number;
  rgDataEmissao?: number;
  rgNumero?: string;
  rgOrgaoEmissor?: string;
  rgOrgaoEmissorDescricao?: string;
  rgUf?: string;
  sexo?: string;
  sexoDescricao?: string;
  stHomologado?: boolean;
  tipoSanguineo?: string;
  foto?: string;

  constructor(data?) {
    if (data) {
      this.acessoPortal = data.acessoPortal;
      this.cadastroMobile = data.cadastroMobile;
      this.cns = data.cns;
      this.cnsCartao = data.cnsCartao;
      this.cpf = data.cpf;
      this.dataNascimento = data.dataNascimento;
      this.doadorOrgao = data.doadorOrgao;
      this.email = data.email;
      this.emailAlternativoValidado = data.emailAlternativoValidado;
      this.emailPrincipalValidado = data.emailPrincipalValidado;
      this.encontradoReceita = data.encontradoReceita;
      this.enderecoBairro = data.enderecoBairro;
      this.enderecoBairroCodigo = data.enderecoBairroCodigo;
      this.enderecoCep = data.enderecoCep;
      this.enderecoCodigo = data.enderecoCodigo;
      this.enderecoComplemento = data.enderecoComplemento;
      this.enderecoLogradouro = data.enderecoLogradouro;
      this.enderecoMunicipio = data.enderecoMunicipio;
      this.enderecoMunicipioCodigo = data.enderecoMunicipioCodigo;
      this.enderecoMunicipioSemUF = data.enderecoMunicipioSemUF;
      this.enderecoNumero = data.enderecoNumero;
      this.enderecoTipoLogradouro = data.enderecoTipoLogradouro;
      this.enderecoTipoLogradouroCodigo = data.enderecoTipoLogradouroCodigo;
      this.etniaIndigena = data.etniaIndigena;
      this.grauQualidade = data.grauQualidade;
      this.listaCns = data.listaCns;
      this.municipioNascimento = data.municipioNascimento;
      this.municipioNascimentoCodigo = data.municipioNascimentoCodigo;
      this.municipioNascimentoSemUF = data.municipioNascimentoSemUF;
      this.nacionalidade = data.nacionalidade;
      this.nomade = data.nomade;
      this.nome = data.nome;
      this.nomeMae = data.nomeMae;
      this.nomePai = data.nomePai;
      this.nomeSocial = data.nomeSocial;
      this.paisNascimento = data.paisNascimento;
      this.paisNascimentoCodigo = data.paisNascimentoCodigo;
      this.paisResidenciaCodigo = data.paisResidenciaCodigo;
      this.paisResidenciaDescricao = data.paisResidenciaDescricao;
      this.racaCor = data.racaCor;
      this.racaCorDescricao = data.racaCorDescricao;
      this.rgCodigo = data.rgCodigo;
      this.rgDataEmissao = data.rgDataEmissao;
      this.rgNumero = data.rgNumero;
      this.rgDataEmissao = data.rgDataEmissao;
      this.rgOrgaoEmissor = data.rgOrgaoEmissor;
      this.rgUf = data.rgUf;
      this.sexo = data.sexo;
      this.sexoDescricao = data.sexoDescricao;
      this.stHomologado = data.stHomologado;
      this.tipoSanguineo = data.tipoSanguineo;
      this.foto = data.foto;
    }
  }

  public static fromDTO?(data) {
    const usuario = new Usuario();
    usuario.acessoPortal = data.acessoPortal;
    usuario.cadastroMobile = data.cadastroMobile;
    usuario.cns = data.cns;
    usuario.cnsCartao = data.cnsCartao;
    usuario.cpf = data.cpf;
    usuario.dataNascimento = data.dataNascimento;
    usuario.doadorOrgao = data.doadorOrgao;
    usuario.email = data.email;
    usuario.emailAlternativoValidado = data.emailAlternativoValidado;
    usuario.emailPrincipalValidado = data.emailPrincipalValidado;
    usuario.encontradoReceita = data.encontradoReceita;
    usuario.enderecoBairro = data.enderecoBairro;
    usuario.enderecoBairroCodigo = data.enderecoBairroCodigo;
    usuario.enderecoCep = data.enderecoCep;
    usuario.enderecoCodigo = data.enderecoCodigo;
    usuario.enderecoComplemento = data.enderecoComplemento;
    usuario.enderecoLogradouro = data.enderecoLogradouro;
    usuario.enderecoMunicipio = data.enderecoMunicipio;
    usuario.enderecoMunicipioCodigo = data.enderecoMunicipioCodigo;
    usuario.enderecoMunicipioSemUF = data.enderecoMunicipioSemUF;
    usuario.enderecoNumero = data.enderecoNumero;
    usuario.enderecoTipoLogradouro = data.enderecoTipoLogradouro;
    usuario.enderecoTipoLogradouroCodigo = data.enderecoTipoLogradouroCodigo;
    usuario.etniaIndigena = data.etniaIndigena;
    usuario.grauQualidade = data.grauQualidade;
    usuario.listaCns = data.listaCns;
    usuario.municipioNascimento = data.municipioNascimento;
    usuario.municipioNascimentoCodigo = data.municipioNascimentoCodigo;
    usuario.municipioNascimentoSemUF = data.municipioNascimentoSemUF;
    usuario.nacionalidade = data.nacionalidade;
    usuario.nomade = data.nomade;
    usuario.nome = data.nome;
    usuario.nomeMae = data.nomeMae;
    usuario.nomePai = data.nomePai;
    usuario.nomeSocial = data.nomeSocial;
    usuario.paisNascimento = data.paisNascimento;
    usuario.paisNascimentoCodigo = data.paisNascimentoCodigo;
    usuario.paisResidenciaCodigo = data.paisResidenciaCodigo;
    usuario.paisResidenciaDescricao = data.paisResidenciaDescricao;
    usuario.racaCor = data.racaCor;
    usuario.racaCorDescricao = data.racaCorDescricao;
    usuario.rgCodigo = data.rgCodigo;
    usuario.rgDataEmissao = data.rgDataEmissao;
    usuario.rgNumero = data.rgNumero;
    usuario.rgDataEmissao = data.rgDataEmissao;
    usuario.rgOrgaoEmissor = data.rgOrgaoEmissor;
    usuario.rgUf = data.rgUf;
    usuario.sexo = data.sexo;
    usuario.sexoDescricao = data.sexoDescricao;
    usuario.stHomologado = data.stHomologado;
    usuario.tipoSanguineo = data.tipoSanguineo;
    usuario.foto = data.foto;

    return usuario;
  }

  public toDTO?() {
    const dto: any = {};
    dto.acessoPortal = this.acessoPortal;
    dto.cadastroMobile = this.cadastroMobile;
    dto.cns = this.cns;
    dto.cnsCartao = this.cnsCartao;
    dto.cpf = this.cpf;
    dto.dataNascimento = this.dataNascimento;
    dto.doadorOrgao = this.doadorOrgao;
    dto.email = this.email;
    dto.emailAlternativoValidado = this.emailAlternativoValidado;
    dto.emailPrincipalValidado = this.emailPrincipalValidado;
    dto.encontradoReceita = this.encontradoReceita;
    dto.enderecoBairro = this.enderecoBairro;
    dto.enderecoBairroCodigo = this.enderecoBairroCodigo;
    dto.enderecoCep = this.enderecoCep;
    dto.enderecoCodigo = this.enderecoCodigo;
    dto.enderecoComplemento = this.enderecoComplemento;
    dto.enderecoLogradouro = this.enderecoLogradouro;
    dto.enderecoMunicipio = this.enderecoMunicipio;
    dto.enderecoMunicipioCodigo = this.enderecoMunicipioCodigo;
    dto.enderecoMunicipioSemUF = this.enderecoMunicipioSemUF;
    dto.enderecoNumero = this.enderecoNumero;
    dto.enderecoTipoLogradouro = this.enderecoTipoLogradouro;
    dto.enderecoTipoLogradouroCodigo = this.enderecoTipoLogradouroCodigo;
    dto.etniaIndigena = this.etniaIndigena;
    dto.grauQualidade = this.grauQualidade;
    dto.listaCns = this.listaCns;
    dto.municipioNascimento = this.municipioNascimento;
    dto.municipioNascimentoCodigo = this.municipioNascimentoCodigo;
    dto.municipioNascimentoSemUF = this.municipioNascimentoSemUF;
    dto.nacionalidade = this.nacionalidade;
    dto.nomade = this.nomade;
    dto.nome = this.nome;
    dto.nomeMae = this.nomeMae;
    dto.nomePai = this.nomePai;
    dto.nomeSocial = this.nomeSocial;
    dto.paisNascimento = this.paisNascimento;
    dto.paisNascimentoCodigo = this.paisNascimentoCodigo;
    dto.paisResidenciaCodigo = this.paisResidenciaCodigo;
    dto.paisResidenciaDescricao = this.paisResidenciaDescricao;
    dto.racaCor = this.racaCor;
    dto.racaCorDescricao = this.racaCorDescricao;
    dto.rgCodigo = this.rgCodigo;
    dto.rgDataEmissao = this.rgDataEmissao;
    dto.rgNumero = this.rgNumero;
    dto.rgDataEmissao = this.rgDataEmissao;
    dto.rgOrgaoEmissor = this.rgOrgaoEmissor;
    dto.rgUf = this.rgUf;
    dto.sexo = this.sexo;
    dto.sexoDescricao = this.sexoDescricao;
    dto.stHomologado = this.stHomologado;
    dto.tipoSanguineo = this.tipoSanguineo;
    dto.foto = this.foto;
    return dto;
  }

}
